/// <reference path='../../modules/app.module.ts'/>
/// <reference path="../../controllers/shell.controller.ts" />

module App {
    var getRoutes = (): App.Interfaces.ICustomState[] => {
        var route: App.Interfaces.ICustomState = {
            name: Constants.routeKeys.notyrechange,
            url: '/' + 'notyrecontact',
            cache: false,
            title: 'Contactgegevens',
            headerTitle: 'Contactgegevens',
            configuratorStepName: ['NoTyreContactStep'],
            order: 1,
            operations: ['SetContactDetails','SetNoTyreContactDetails'],
            views: {
                [Constants.viewRegions.appContent]: {
                    templateUrl: '/templates/noTyreChangeContact.html',
                    controller: Controllers.NoTyreChangeContactController.controllerId + ' as vm'
                }
            },
            showInMenu: true
        }

        return [route];
    }

    function appRun(routehelper: Blocks.Interfaces.IRouterFactory) {
        routehelper.configureRoutes(getRoutes());
    }

    App.Core.appCore.run(appRun);
}